import { render, staticRenderFns } from "./SettingsUserIcon.vue?vue&type=template&id=b40173c4&scoped=true"
import script from "./SettingsUserIcon.vue?vue&type=script&lang=js"
export * from "./SettingsUserIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b40173c4",
  null
  
)

export default component.exports